// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms-card {
  width: 38.75rem;
  margin: 0 auto;
  border-radius: 10px;
  margin-bottom: 20px;
}

.terms-title {
  color: #d2042d;
  font-size: 19px;
  font-family: Roboto;
  font-weight: 500;
}
.request-status-sec {
  height: 22px;
  width: 90px;
  border-radius: 5px;
  background-color: #d2042d;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 13px;
}
.panel-title {
  color: #d2042d;
  font-size: 16px;
  font-weight: 500;
  font-family: Roboto;
}

.with-drawn-txt {
  font-size: 13px;
  color: #fff;
  font-style: "Roboto";
}

.icon-arrow {
  font-size: 16px;
  color: #d2042d;
  margin-top: 5px;
}
.requests-table .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
  display: inline-flex;
  align-items: center;
  font-size: 16px;
  color: #d2042d;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 12px;
  transition: transform 0.3s;
}
.requests-table .ant-collapse > .ant-collapse-item > .ant-collapse-header {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  padding: 13px 0px !important;
  color: rgba(0, 0, 0, 0.88);
  line-height: 1.5714285714285714;
  cursor: pointer;
  transition:
    all 0.3s,
    visibility 0s;
}

.terms-info-row {
  font-size: 14px;
  font-weight: 400;
  color: #5b5e5d;
  font-family: Roboto;
}
.terms-info-row-txt {
  font-size: 16px;
  font-weight: 600;
  color: #0a0f0d;
  font-family: Roboto;
}

.terms-total {
  margin-top: 16px;
}

.terms-actions {
  margin-top: 24px;
  text-align: right;
}
.terms-accept-btn {
  background-color: #d2042d;
  height: 43px;
  color: #fff;
  font-family: Roboto;

  font-weight: 500;
  font-size: 16px;

  border: none;
}
.terms-accept-btn:hover {
  background-color: #d2042d !important;
  height: 43px;
  color: #fff !important;
  border: none;
}

.reject-btn {
  height: 43px;
  font-weight: 500;
  font-size: 16px;
  margin-right: 12px;
  border: none;
  color: #0a0f0d;
  font-family: Roboto;

  background-color: #f0f0f0;
}
.reject-btn:hover {
  height: 43px;
  font-weight: 500;
  font-size: 16px;
  margin-right: 12px;
  border: none;
  color: #0a0f0d !important;
  background-color: #f0f0f0 !important;
}
.header-date {
  font-size: 13px;
  font-weight: 500;
  color: #5b5e5d;
  font-family: Roboto;
}
.terms-installment {
  color: #d2042d;
  font-size: 14px;
  font-weight: 400;
  font-family: Roboto;
}
.row-gap {
  margin-top: 20px;
}
.ant-card .ant-card-head-wrapper {
  width: 100%;
  display: flex;
  align-items: baseline !important;
}
.accept-confirm-modal .ant-modal-confirm-title {
  font-size: 19px;
  font-weight: 500;
  color: #000;
}
.accept-confirm-modal .ant-modal-confirm-content {
  font-size: 14px;
  font-weight: 400;
  color: #5b5e5d;
}
.accept-confirm-modal.ant-modal-confirm .ant-modal-confirm-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.accept-confirm-modal.ant-modal-confirm
  .anticon
  + .ant-modal-confirm-paragraph {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.accept-confirm-modal.ant-modal-confirm .ant-modal-confirm-body > .anticon {
  font-size: 30px !important;
}
@media (min-width: 425px) and (max-width: 720px) {
  .terms-card {
    width: 100% !important;
    margin: 0 auto;
    border-radius: 10px;
  }
}

@media (min-width: 320px) and (max-width: 435px) {
  .terms-card {
    width: 100%;
    border-radius: 10px;
  }
  .terms-accept-btn {
    background-color: #d2042d;
    height: 43px;
    color: #fff;
    font-family: Roboto;
    font-weight: 400;
    font-size: 15px;
    border: none;
  }
  .reject-btn {
    height: 43px;
    font-weight: 400;
    font-size: 15px;
    margin-right: 12px;
    border: none;
    color: #0a0f0d;
    font-family: Roboto;
    background-color: #f0f0f0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/terms-requests/TermsRequestCard.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,eAAe;EACf;;iBAEe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,mBAAmB;;EAEnB,gBAAgB;EAChB,eAAe;;EAEf,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,mBAAmB;;EAEnB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,oCAAoC;AACtC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE;IACE,sBAAsB;IACtB,cAAc;IACd,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,YAAY;EACd;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,yBAAyB;EAC3B;AACF","sourcesContent":[".terms-card {\n  width: 38.75rem;\n  margin: 0 auto;\n  border-radius: 10px;\n  margin-bottom: 20px;\n}\n\n.terms-title {\n  color: #d2042d;\n  font-size: 19px;\n  font-family: Roboto;\n  font-weight: 500;\n}\n.request-status-sec {\n  height: 22px;\n  width: 90px;\n  border-radius: 5px;\n  background-color: #d2042d;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 13px;\n}\n.panel-title {\n  color: #d2042d;\n  font-size: 16px;\n  font-weight: 500;\n  font-family: Roboto;\n}\n\n.with-drawn-txt {\n  font-size: 13px;\n  color: #fff;\n  font-style: \"Roboto\";\n}\n\n.icon-arrow {\n  font-size: 16px;\n  color: #d2042d;\n  margin-top: 5px;\n}\n.requests-table .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {\n  display: inline-flex;\n  align-items: center;\n  font-size: 16px;\n  color: #d2042d;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-size: 12px;\n  transition: transform 0.3s;\n}\n.requests-table .ant-collapse > .ant-collapse-item > .ant-collapse-header {\n  position: relative;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: flex-start;\n  padding: 13px 0px !important;\n  color: rgba(0, 0, 0, 0.88);\n  line-height: 1.5714285714285714;\n  cursor: pointer;\n  transition:\n    all 0.3s,\n    visibility 0s;\n}\n\n.terms-info-row {\n  font-size: 14px;\n  font-weight: 400;\n  color: #5b5e5d;\n  font-family: Roboto;\n}\n.terms-info-row-txt {\n  font-size: 16px;\n  font-weight: 600;\n  color: #0a0f0d;\n  font-family: Roboto;\n}\n\n.terms-total {\n  margin-top: 16px;\n}\n\n.terms-actions {\n  margin-top: 24px;\n  text-align: right;\n}\n.terms-accept-btn {\n  background-color: #d2042d;\n  height: 43px;\n  color: #fff;\n  font-family: Roboto;\n\n  font-weight: 500;\n  font-size: 16px;\n\n  border: none;\n}\n.terms-accept-btn:hover {\n  background-color: #d2042d !important;\n  height: 43px;\n  color: #fff !important;\n  border: none;\n}\n\n.reject-btn {\n  height: 43px;\n  font-weight: 500;\n  font-size: 16px;\n  margin-right: 12px;\n  border: none;\n  color: #0a0f0d;\n  font-family: Roboto;\n\n  background-color: #f0f0f0;\n}\n.reject-btn:hover {\n  height: 43px;\n  font-weight: 500;\n  font-size: 16px;\n  margin-right: 12px;\n  border: none;\n  color: #0a0f0d !important;\n  background-color: #f0f0f0 !important;\n}\n.header-date {\n  font-size: 13px;\n  font-weight: 500;\n  color: #5b5e5d;\n  font-family: Roboto;\n}\n.terms-installment {\n  color: #d2042d;\n  font-size: 14px;\n  font-weight: 400;\n  font-family: Roboto;\n}\n.row-gap {\n  margin-top: 20px;\n}\n.ant-card .ant-card-head-wrapper {\n  width: 100%;\n  display: flex;\n  align-items: baseline !important;\n}\n.accept-confirm-modal .ant-modal-confirm-title {\n  font-size: 19px;\n  font-weight: 500;\n  color: #000;\n}\n.accept-confirm-modal .ant-modal-confirm-content {\n  font-size: 14px;\n  font-weight: 400;\n  color: #5b5e5d;\n}\n.accept-confirm-modal.ant-modal-confirm .ant-modal-confirm-body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.accept-confirm-modal.ant-modal-confirm\n  .anticon\n  + .ant-modal-confirm-paragraph {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.accept-confirm-modal.ant-modal-confirm .ant-modal-confirm-body > .anticon {\n  font-size: 30px !important;\n}\n@media (min-width: 425px) and (max-width: 720px) {\n  .terms-card {\n    width: 100% !important;\n    margin: 0 auto;\n    border-radius: 10px;\n  }\n}\n\n@media (min-width: 320px) and (max-width: 435px) {\n  .terms-card {\n    width: 100%;\n    border-radius: 10px;\n  }\n  .terms-accept-btn {\n    background-color: #d2042d;\n    height: 43px;\n    color: #fff;\n    font-family: Roboto;\n    font-weight: 400;\n    font-size: 15px;\n    border: none;\n  }\n  .reject-btn {\n    height: 43px;\n    font-weight: 400;\n    font-size: 15px;\n    margin-right: 12px;\n    border: none;\n    color: #0a0f0d;\n    font-family: Roboto;\n    background-color: #f0f0f0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
